import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import * as OrganizationMasterService from "../../Services/OrganizationMaster/OrganizationMasterService";
import toast from "react-hot-toast";
import { useState } from "react";
import { FaSpinner } from "react-icons/fa";

const OrgLocationMappingModal = ({
  showModal,
  setShowModal,
  orgNames,
  fetchOrganizationMasterList,
}) => {
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setLoading(true);

    const payload = {
      OrganizationId: data.organization.value,
      OrganizationName: data.organization.label,
      OrgLocationId: Number(data.orglocationid),
      OrgLocationName: data.orglocationname,
      Is_Processing_Location: data.is_Processing_Location,
    };

    OrganizationMasterService.AddOrgLocationMapping(payload)
      .then(({ data }) => {
        if (data.IsSuccess) {
          toast.success(data.ResponseMessage);
          setShowModal(false);
          fetchOrganizationMasterList();
        } else {
          toast.error(data.ResponseMessage);
        }
      })
      .catch(() => toast.error("Something went wrong during creation."))
      .finally(() => {
        setLoading(false);
      });
  };

  const renderError = (fieldName, errors) => {
    if (!errors || !fieldName) return null;
    const error = errors[fieldName];
    return error ? <p className="text-danger">{error.message}</p> : null;
  };

  return (
    <div>
      <div className="modal-backdrop">
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div
            className="modal-dialog modal-sm custom-modal-com"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Mapping</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowModal(false);
                  }}
                ></button>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="modal-body">
                  <div>
                    <div className="mb-2">
                      <label className="fw-bold required mb-2">Org Name</label>

                      <Controller
                        name="organization"
                        control={control}
                        rules={{ required: "Org name is required" }}
                        render={({ field }) => (
                          <Select
                            options={orgNames?.map((item) => ({
                              value: item.OrganizationId,
                              label: item.OrganizationName,
                            }))}
                            placeholder="-- Select Org Name --"
                            isSearchable
                            value={field.value}
                            onChange={(option) => field.onChange(option)}
                            onBlur={field.onBlur}
                          />
                        )}
                      />

                      {renderError("organization", errors)}
                    </div>

                    <div className="mb-2">
                      <label className="fw-bold required mb-2">
                        Org Location ID
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("orglocationid", {
                          required: "Org Location ID is required",
                        })}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            "",
                          );
                        }}
                      />
                      {renderError("orglocationid", errors)}
                    </div>

                    <div className="mb-2">
                      <label className="fw-bold required mb-2">
                        Org Location Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("orglocationname", {
                          required: "Org Location Name is required",
                        })}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^A-Za-z\s]/g,
                            "",
                          );
                        }}
                      />
                      {renderError("orglocationname", errors)}
                    </div>

                    <div className="align-self-end mb-2">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          {...register("is_Processing_Location")}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              e.target.checked = !e.target.checked;
                              e.target.dispatchEvent(
                                new Event("change", { bubbles: true }),
                              );
                            }
                          }}
                        />
                        <label className="form-check-label fw-bold">
                          Is Processing Location
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-danger"
                    tabIndex={-1}
                    onClick={() => {
                      setShowModal(false);
                    }}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn custom-sumbitbtn">
                    {loading ? <FaSpinner className="fa-spin mb-1" /> : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrgLocationMappingModal;
